export default "__VITE_ASSET__cV5UC60m__"